import { gql } from "@apollo/client";

export const PARTNER_EXTRA_INFO_QUERY = gql`
  query partnerExtraInfos($partnerId: Int!) {
    partnerExtraInfos(partnerId: $partnerId) {
      data {
        sections {
          columns {
            caption
            propertyName
            propertyType
            required
            propertyCode
          }
          extraInformationId
          jsonData
          name
          display
          textArea
        }
      }
      partnerId
    }
  }
`;
